// routes/_embedded.embedded.chat-editing.creator.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_embedded.embedded.chat-editing.creator')

export const handle = { name: 'embedded-chat-editing-creator' }

export default dynamic(getClientModule, { ssr: false })
